import { Form } from "@/components/elements/Form";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { Modal } from "@/components/elements/Modal";
import { passkeySchema, TPasskeyForm } from "@/components/commons/PasskeyManager/passkeySchema";
import { text } from "@/theme/colors";
import { yupResolver } from "@hookform/resolvers/yup";
import { Stack, Typography } from "@mui/material";
import { FC, useEffect } from "react";
import { useForm } from "react-hook-form";

type TAddPasskeyModalProps = {
  isOpen: boolean;
  isRegistering: boolean;
  onOk: (deviceName: string) => void;
  onClose: () => void;
};

export const AddPasskeyModal: FC<TAddPasskeyModalProps> = ({ isOpen, isRegistering, onOk, onClose }) => {
  const methods = useForm<TPasskeyForm>({
    defaultValues: { deviceName: "" },
    resolver: yupResolver(passkeySchema),
    mode: "all",
    reValidateMode: "onBlur",
  });
  const { control, reset } = methods;

  useEffect(() => {
    if (isOpen) reset({ deviceName: "" });
  }, [isOpen, reset]);

  const handleValid = ({ deviceName }: TPasskeyForm) => onOk(deviceName.trim());

  return (
    <Modal
      isOpen={isOpen}
      title="パスキーを追加"
      labelOk="登録する"
      labelClose="キャンセル"
      isLoadingOkBtn={isRegistering}
      onOk={methods.handleSubmit(handleValid)}
      onClose={onClose}
    >
      <Stack gap={4} py="8px" mb="16px" width={360}>
        <Typography variant="body14" color={text.secondary}>
          デバイス名を入力して「登録する」を押すと、お使いの端末でパスキーの作成が始まります。
        </Typography>
        <Form methods={methods} onSubmit={handleValid} enableBlocker={false} schema={passkeySchema}>
          <FormField control={control} name="deviceName">
            <Input size="lg" placeholder="入力してください" />
          </FormField>
        </Form>
      </Stack>
    </Modal>
  );
};
